import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["prefixDataTestId", "singleContent", "shortMobileLabels", "showRoomInventory", "styles", "labelStyles", "isScrollable", "isMobileView", "hasRoomLabels", "options", "orientation", "variant", "setStartingTab", "startingTab", "tabScrollSize", "index", "defaultIndex", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Text, useMultiStyleConfig } from '@chakra-ui/react';
import { formatDataTestId, ternaryCondition, useSemanticTypography } from '@whitbread-eos/utils';
import dynamic from 'next/dynamic';
import { useState, useEffect, useId } from 'react';
import { Info as InfoIcon, RoundedArrowRight, RoundedArrowLeft } from '../../assets/icons';
import { semanticTextStyles } from '../../theme/adapters/semanticTypography';
import { truncateLabel } from '../../utils/truncateLabel';
import Button from '../Button';
import Icon from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Tooltip = dynamic(_asyncToGenerator(function* () {
  var _yield$import = yield import('../Tooltip/Tooltip.component'),
    Tooltip = _yield$import.default;
  return {
    default: Tooltip
  };
}), {
  ssr: false
});
var ROOM_COUNT_OVERFLOW = 7;
var LABEL_LENGTH_OVERFLOW = 7;
export default function Tabs(_ref2) {
  var _ref3, _ref4, _ref5;
  var prefixDataTestId = _ref2.prefixDataTestId,
    singleContent = _ref2.singleContent,
    _ref2$shortMobileLabe = _ref2.shortMobileLabels,
    shortMobileLabels = _ref2$shortMobileLabe === void 0 ? false : _ref2$shortMobileLabe,
    _ref2$showRoomInvento = _ref2.showRoomInventory,
    showRoomInventory = _ref2$showRoomInvento === void 0 ? false : _ref2$showRoomInvento,
    styles = _ref2.styles,
    labelStyles = _ref2.labelStyles,
    isScrollable = _ref2.isScrollable,
    isMobileView = _ref2.isMobileView,
    hasRoomLabels = _ref2.hasRoomLabels,
    optionsProp = _ref2.options,
    orientation = _ref2.orientation,
    variant = _ref2.variant,
    setStartingTab = _ref2.setStartingTab,
    startingTab = _ref2.startingTab,
    tabScrollSizeProp = _ref2.tabScrollSize,
    indexProp = _ref2.index,
    defaultIndex = _ref2.defaultIndex,
    onChange = _ref2.onChange,
    boxProps = _objectWithoutProperties(_ref2, _excluded);
  var options = optionsProp !== null && optionsProp !== void 0 ? optionsProp : [];
  var tabsId = useId();
  var getTypographyProps = useSemanticTypography();
  var _useState = useState((_ref3 = (_ref4 = indexProp !== null && indexProp !== void 0 ? indexProp : defaultIndex) !== null && _ref4 !== void 0 ? _ref4 : startingTab) !== null && _ref3 !== void 0 ? _ref3 : 0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedIndex = _useState2[0],
    setSelectedIndex = _useState2[1];
  useEffect(() => {
    if (indexProp !== undefined) {
      setSelectedIndex(indexProp);
    }
  }, [indexProp]);
  useEffect(() => {
    if (startingTab !== undefined) {
      setSelectedIndex(startingTab);
    }
  }, [startingTab]);
  var tabStyles = useMultiStyleConfig('Tabs', {
    variant,
    orientation
  });
  var handleTabClick = newIndex => {
    setSelectedIndex(newIndex);
    onChange === null || onChange === void 0 || onChange(newIndex);
    setStartingTab === null || setStartingTab === void 0 || setStartingTab(newIndex);
  };
  var currentTab = startingTab !== null && startingTab !== void 0 ? startingTab : selectedIndex;
  var tabScrollSize = tabScrollSizeProp !== null && tabScrollSizeProp !== void 0 ? tabScrollSizeProp : 0;
  var isDisabledLeftArrow = currentTab <= 0;
  var isDisabledRightArrow = currentTab + tabScrollSize >= options.length;
  return _jsxs(Box, _objectSpread(_objectSpread({}, boxProps), {}, {
    "data-testid": formatDataTestId(prefixDataTestId, 'TabsComponent'),
    sx: _objectSpread(_objectSpread({}, isScrollable ? scrollableTabsStyles : {}), (_ref5 = boxProps.sx) !== null && _ref5 !== void 0 ? _ref5 : {}),
    __css: tabStyles.root,
    children: [_jsxs(Box, _objectSpread(_objectSpread({
      role: "tablist",
      display: "flex",
      __css: tabStyles.tablist
    }, styles === null || styles === void 0 ? void 0 : styles.tabList), {}, {
      children: [isScrollable && _jsx(Button, {
        "data-testid": formatDataTestId('TabScrollLeft', 'Button'),
        className: "tabs-scroll-arrow tabs-scroll-arrow--left",
        variant: "tertiary",
        isDisabled: isDisabledLeftArrow,
        onClick: () => {
          if (currentTab - tabScrollSize < 0) {
            handleTabClick(currentTab - 1);
          } else {
            handleTabClick(currentTab - tabScrollSize);
          }
        },
        children: _jsx(Icon, {
          svg: _jsx(RoundedArrowLeft, {
            color: isDisabledLeftArrow ? 'var(--chakra-colors-lightGrey2)' : ''
          })
        })
      }), options.map((option, i) => {
        var _option$index, _option$index2;
        var idx = (_option$index = option.index) !== null && _option$index !== void 0 ? _option$index : i;
        var isSelected = selectedIndex === idx;
        return _jsx(Box, _objectSpread(_objectSpread({
          as: "button",
          type: "button",
          role: "tab",
          id: "".concat(tabsId, "-tab-").concat(idx),
          "aria-selected": isSelected,
          "aria-controls": "".concat(tabsId, "-panel-").concat(idx),
          tabIndex: isSelected ? 0 : -1,
          px: 1,
          "data-testid": formatDataTestId(option.label, 'TabButton'),
          onClick: () => handleTabClick(idx),
          __css: tabStyles.tab
        }, styles === null || styles === void 0 ? void 0 : styles.tab), {}, {
          display: !isScrollable || currentTab === idx || currentTab + 1 === idx ? 'flex' : 'none',
          children: _jsxs(Flex, {
            flexDir: "column",
            width: "100%",
            "data-testid": formatDataTestId(option.label, 'TabButtonColumn'),
            children: [ternaryCondition(showRoomInventory, renderRoomInventoryLabel(option.label, option.roomTypeInventoryCount, option.roomTypeInventoryRoomTypesWithCount), renderLabel(options.length > ROOM_COUNT_OVERFLOW, shortMobileLabels, (_option$index2 = option.index) !== null && _option$index2 !== void 0 ? _option$index2 : 0, option.label, isSelected)), !!option.description && renderDescription(option.description, options.length > ROOM_COUNT_OVERFLOW, shortMobileLabels), !!option.images && option.images]
          })
        }), idx);
      }), isScrollable && _jsx(Button, {
        "data-testid": formatDataTestId('TabScrollRight', 'Button'),
        className: "tabs-scroll-arrow tabs-scroll-arrow--right",
        variant: "tertiary",
        onClick: () => {
          if (currentTab + tabScrollSize + 1 >= options.length) {
            handleTabClick(currentTab + 1);
          } else {
            handleTabClick(currentTab + tabScrollSize);
          }
        },
        isDisabled: isDisabledRightArrow,
        children: _jsx(Icon, {
          svg: _jsx(RoundedArrowRight, {
            color: isDisabledRightArrow ? 'var(--chakra-colors-lightGrey2)' : ''
          })
        })
      })]
    })), singleContent ? singleContent : _jsx(Box, {
      "data-testid": formatDataTestId(prefixDataTestId, 'TabPanels'),
      children: optionsProp === null || optionsProp === void 0 ? void 0 : optionsProp.map((option, i) => {
        var _option$index3;
        var idx = (_option$index3 = option.index) !== null && _option$index3 !== void 0 ? _option$index3 : i;
        if (selectedIndex !== idx) return null;
        return _jsx(Box, _objectSpread(_objectSpread({
          role: "tabpanel",
          id: "".concat(tabsId, "-panel-").concat(idx),
          "aria-labelledby": "".concat(tabsId, "-tab-").concat(idx),
          __css: tabStyles.tabpanel
        }, styles === null || styles === void 0 ? void 0 : styles.tabPanel), {}, {
          children: option.content
        }), idx);
      })
    })]
  }));
  function renderRoomInventoryLabel(label, roomTypeInventoryCount, roomTypeInventoryRoomTypesWithCount) {
    if (roomTypeInventoryCount && roomTypeInventoryRoomTypesWithCount) {
      return _jsx(Tooltip, {
        description: roomTypeInventoryRoomTypesWithCount,
        variant: 'infoGrey',
        svg: _jsx(InfoIcon, {}),
        placement: "bottom-start",
        children: _jsxs(Text, {
          as: "h4",
          "data-testid": formatDataTestId(label, 'TabButtonWithToolTipLabel'),
          children: [label, " (", roomTypeInventoryCount, ")"]
        })
      });
    } else {
      return _jsxs(Text, {
        as: "h4",
        "data-testid": formatDataTestId(label, 'TabButtonLabel'),
        children: [label, " (", roomTypeInventoryCount, ")"]
      });
    }
  }
  function formatLabel(label, index) {
    if (hasRoomLabels) {
      if (isMobileView && !isScrollable) {
        return index + 1;
      } else {
        return label;
      }
    }
    return truncateLabel(label, LABEL_LENGTH_OVERFLOW);
  }
  function renderLabel(overflow, shortMobileLabels, index) {
    var _labelStyles$selected, _labelStyles$unselect;
    var label = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var isSelected = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var tabsLabelLegacyTypography = hasRoomLabels ? {
      fontSize: '17px'
    } : {};
    var tabsLabelSemanticTypography = isSelected ? (_labelStyles$selected = labelStyles === null || labelStyles === void 0 ? void 0 : labelStyles.selected) !== null && _labelStyles$selected !== void 0 ? _labelStyles$selected : {} : (_labelStyles$unselect = labelStyles === null || labelStyles === void 0 ? void 0 : labelStyles.unselected) !== null && _labelStyles$unselect !== void 0 ? _labelStyles$unselect : {};
    var tabsLabelTypographyProps = getTypographyProps(tabsLabelLegacyTypography, tabsLabelSemanticTypography);
    if (shortMobileLabels && overflow) {
      return _jsx(Tooltip, {
        description: label,
        variant: 'infoGrey',
        svg: _jsx(InfoIcon, {}),
        children: _jsx(Text, _objectSpread(_objectSpread({
          as: "h3",
          "data-testid": formatDataTestId(label, 'TabButtonLabel'),
          style: {
            fontSize: '17px'
          }
        }, tabsLabelTypographyProps), {}, {
          children: formatLabel(label, index)
        }))
      });
    } else {
      return _jsx(Text, _objectSpread(_objectSpread({
        as: "h3",
        "data-testid": formatDataTestId(label, 'TabButtonLabel')
      }, tabsLabelTypographyProps), {}, {
        children: label
      }));
    }
  }
  function renderDescription(description, overflow, shortMobileLabels) {
    var tabDescriptionTypographyProps = getTypographyProps({}, tabDescriptionSemanticTypography);
    var isSemanticDescription = 'textStyle' in tabDescriptionTypographyProps;
    var tabDescriptionSemanticStyle = isSemanticDescription ? semanticTextStyles[tabDescriptionSemanticTypography.textStyle] : undefined;
    if (shortMobileLabels && overflow) {
      return _jsx(Tooltip, {
        description: description,
        variant: 'infoGrey',
        svg: _jsx(InfoIcon, {}),
        children: _jsx(Text, {
          as: "h5",
          "data-testid": formatDataTestId(description, 'TabButtonDescription'),
          style: tabDescriptionSemanticStyle,
          children: description.substring(0, LABEL_LENGTH_OVERFLOW - 3) + '...'
        })
      });
    } else {
      return _jsx(Text, {
        as: "h5",
        "data-testid": formatDataTestId(description, 'TabButtonDescription'),
        style: tabDescriptionSemanticStyle,
        children: description
      });
    }
  }
}
var tabDescriptionSemanticTypography = {
  textStyle: 'body-s-regular'
};
var scrollableTabsStyles = {
  '.tabs-scroll-arrow': {
    width: '35px',
    '&:disabled': {
      backgroundColor: 'lightGrey5'
    },
    '&:hover:disabled': {
      backgroundColor: 'lightGrey5'
    }
  }
};